<div class="shell">
  <header class="shell__header">
    <app-header></app-header>
  </header>
  <main>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </main>
</div>
